'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = QualityMenu;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _MenuHeader = require('../MenuHeader');

var _MenuHeader2 = _interopRequireDefault(_MenuHeader);

var _MenuOption = require('../MenuOption');

var _MenuOption2 = _interopRequireDefault(_MenuOption);

var _style = require('./style.css');

var _g11n = require('../../../shared/g11n');

var _g11n2 = _interopRequireDefault(_g11n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-multi-comp, consistent-return */
/**
 * Copyright 2013-2015, Hudl
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule QualityMenu
 */

var title = (0, _g11n2.default)('vi.player.menus.quality');
var auto = (0, _g11n2.default)('vi.player.menus.auto');

function qualityChangeLoader(qualityChangeLoading) {
  if (qualityChangeLoading) {
    return _react2.default.createElement('div', { className: 'spinner css-spinner ' + _style.optionSpinner });
  }
}

function isActive(quality, currentQuality) {
  var key = 'NONE';
  if (currentQuality) {
    key = currentQuality.get('key');
  } else if (quality.get('key').indexOf('Auto') > -1) {
    key = quality.get('key');
  }
  return quality.get('key') === key;
}

function QualityMenu(_ref) {
  var _this = this;

  var currentQuality = _ref.currentQuality,
      onHeaderClick = _ref.onHeaderClick,
      onOptionClick = _ref.onOptionClick,
      qualities = _ref.qualities,
      qualityChangeLoading = _ref.qualityChangeLoading;

  var qualityDOMArray = qualities.map(function (quality, i) {
    var label = quality.get('label');

    return _react2.default.createElement(_MenuOption2.default, {
      key: label + '-' + i,
      onClick: onOptionClick.bind(null, quality),
      label: label.replace(/auto/i, auto),
      active: isActive(quality, currentQuality),
      loadingStateCheck: qualityChangeLoader.bind(_this),
      qualityChangeLoading: qualityChangeLoading
    });
  });

  return _react2.default.createElement(
    _MenuHeader2.default,
    { label: title, onClick: onHeaderClick },
    _react2.default.createElement(
      'ul',
      null,
      qualityDOMArray
    )
  );
}

QualityMenu.propTypes = {
  qualityChangeLoading: _propTypes2.default.bool.isRequired,
  qualities: _propTypes2.default.array.isRequired,
  currentQuality: _propTypes2.default.object,
  selectedQuality: _propTypes2.default.object,
  onHeaderClick: _propTypes2.default.func.isRequired,
  onOptionClick: _propTypes2.default.func.isRequired
};
module.exports = exports['default'];